import { Component } from '@angular/core';
import { ORCIDOtherNameEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Other Names') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidothername-form',
    templateUrl: './orcidothername.form.component.html'
})
export class ORCIDOtherNameFormComponent extends BaseFormComponent {
    public record!: ORCIDOtherNameEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

